<script setup>
// Confirmation that the agent's credentials resolved.
//
// The raw chatbot/WABA identifiers only render outside production — the controller ships
// `debug` alongside them and omits the WABA entirely in production. What guards against
// messaging from the wrong brand there is the sending number, shown in the dispatch dialog.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

defineProps({
  integration: { type: Object, default: null },
  loading: { type: Boolean, default: false },
});

const { t } = useI18n();

const route = useRoute();
// Integrações, não o agente: o token do HubSpot é credencial da CONTA. O `accountId`
// precisa ir explícito — Vue Router 4 não herda param de rota nomeada, e sem ele o link
// aponta para um caminho inválido.
const linkDoToken = computed(() => ({
  name: 'settings_applications',
  params: { accountId: route.params.accountId },
}));
</script>

<template>
  <p v-if="loading" class="mt-3 text-xs text-n-slate-10">
    {{ t('OUTBOUNDS.AGENT.LOADING_INTEGRATION') }}
  </p>

  <div
    v-else-if="integration"
    class="px-4 py-3 mt-3 rounded-xl border border-n-teal-6 bg-n-teal-2"
  >
    <p class="flex items-center gap-2 text-xs font-semibold text-n-teal-11">
      <i class="i-lucide-check-circle-2 size-4" />
      {{ t('OUTBOUNDS.AGENT.INTEGRATION_LOADED') }}
    </p>
    <p v-if="integration.debug" class="mt-1 font-mono text-xs text-n-slate-11">
      {{
        t('OUTBOUNDS.AGENT.INTEGRATION_IDS', {
          chatbotId: integration.id,
          waba: integration.waba || '—',
        })
      }}
    </p>
    <p
      v-else-if="integration.chatbot_phone"
      class="mt-1 text-xs text-n-slate-11"
    >
      {{
        t('OUTBOUNDS.AGENT.INTEGRATION_SENDER', {
          phone: integration.chatbot_phone,
        })
      }}
    </p>

    <!-- A missing token is not fatal here — it only rules out one of the three origins —
         so it reads as a note, not an error. -->
    <!-- Sem o caminho, "sem token" vira um beco: o operador lê que falta algo e não descobre
         onde pôr. O link leva direto à tela que resolve. -->
    <p
      v-if="!integration.has_hubspot_token"
      class="mt-1 text-xs text-n-amber-11"
    >
      {{ t('OUTBOUNDS.AGENT.NO_HUBSPOT_TOKEN') }}
      <router-link :to="linkDoToken" class="underline hover:no-underline">
        {{ t('OUTBOUNDS.AGENT.CONFIGURE_HUBSPOT') }}
      </router-link>
    </p>
  </div>
</template>
